// @flow
import { createReducer } from "reduxsauce";
import I18n from "../i18n/I18n";
import Types from "../actions/Types";

// Init State
export const INITIAL_STATE = {
  products: null,
  offers: null,
  errorMessage: null,
  successMessage: null,
  isLoading: false,
  isListLoading: false,
  isSearchLoading: false,
  isExportLoading: false,
  isExportAllLoading: false,
  isImportLoading: false,
  isImportCompleted: false
};

/* Generic error message */
const genericError = "Something went wrong";

/* Get products */
export const getProducts = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true
  };
};

export const getProductsSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    products: action.products,
    isLoading: false
  };
};

export const getProductsFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isLoading: false,
  errorMessage: (action && action.error) || genericError
});

/* Get products */
export const getProductCount = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isCounting: true
  };
};

export const getProductCountSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    isCounting: false,
    count: action.count
  };
};

export const getProductCountFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isCounting: false,
  // errorMessage: (action && action.error) || genericError
});

/* Search products */
export const searchProducts = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isSearchLoading: true
  };
};

export const searchProductsSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    products: action.products,
    isSearchLoading: false
  };
};

export const searchProductsFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => ({
  ...state,
  isSearchLoading: false,
  errorMessage: (action && action.error) || genericError
});

/* Post products */
export const postProducts = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true,
    successMessage: null,
    errorMessage: null
  };
};

export const postProductsSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Pro success";
  return {
    ...state,
    products: action.products,
    successMessage,
    isLoading: false
  };
};

export const postProductsFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError,
    isLoading: false
  };
};

/* Export Offers */
export const exportOffers = (state: Object = INITIAL_STATE, action: Object) => {
  return {
    ...state,
    isExportLoading: action.offers && action.offers.id_offers,
    isExportAllLoading: action.offers && !action.offers.id_offers,
    successMessage: null,
    errorMessage: null
  };
};

export const exportOffersSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Offers exported successfully";
  return {
    ...state,
    offers: action.offers,
    successMessage,
    isExportLoading: false,
    isExportAllLoading: false
  };
};

export const exportOffersFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError,
    isExportLoading: false,
    isExportAllLoading: false
  };
};

/* Export Offers */
export const exportPSku = state => {
  return {
    ...state,
    isPSkuLoading: true
  };
};

export const exportPSkuSuccess = state => {
  return {
    ...state,
    isPSkuLoading: false
  };
};

export const exportPSkuFailure = (state, action) => {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError,
    isPSkuLoading: false
  };
};

/* Activate products */
export const activateOffers = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isListLoading: true,
    successMessage: null,
    errorMessage: null
  };
};

export const activateOffersSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Pro success";
  return {
    ...state,
    products: action.products,
    successMessage,
    isListLoading: false
  };
};

export const activateOffersFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError,
    isListLoading: false
  };
};

/* Delete products */
export const deleteOffers = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isListLoading: true,
    successMessage: null,
    errorMessage: null
  };
};

export const deleteOffersSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Pro success";
  return {
    ...state,
    products: action.products,
    successMessage,
    isListLoading: false
  };
};

export const deleteOffersFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError,
    isListLoading: false
  };
};

/* Export Offers */
export const importOffers = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isImportLoading: true,
    successMessage: null,
    errorMessage: null,
    isImportCompleted: false
  };
};

export const importOffersSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Offers imported successfully";
  return {
    ...state,
    successMessage,
    isImportLoading: false,
    isImportCompleted: true
  };
};

export const importOffersFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError,
    isImportLoading: false,
    isImportCompleted: true
  };
};

/*  importPSkuUnique */
export const importPSkuUnique = (state: Object = INITIAL_STATE) => {
  return {
    ...state,
    isImportLoading: true,
    successMessage: null,
    errorMessage: null,
    isImportCompleted: false
  };
};

export const importPSkuUniqueSuccess = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  const successMessage = "Offers imported successfully";
  return {
    ...state,
    successMessage,
    documentBatchId: action.documentBatchId,
    isImportLoading: false,
    isImportCompleted: true
  };
};

export const importPSkuUniqueFailure = (
  state: Object = INITIAL_STATE,
  action: Object
) => {
  return {
    ...state,
    errorMessage: (action && action.error) || genericError,
    isImportLoading: false,
    isImportCompleted: true
  };
};

const ACTION_HANDLERS = {
  [Types.GET_PRODUCTS]: getProducts,
  [Types.GET_PRODUCTS_SUCCESS]: getProductsSuccess,
  [Types.GET_PRODUCTS_FAILURE]: getProductsFailure,
  [Types.GET_PRODUCT_COUNT]: getProductCount,
  [Types.GET_PRODUCT_COUNT_SUCCESS]: getProductCountSuccess,
  [Types.GET_PRODUCT_COUNT_FAILURE]: getProductCountFailure,
  [Types.SEARCH_PRODUCTS]: searchProducts,
  [Types.SEARCH_PRODUCTS_SUCCESS]: searchProductsSuccess,
  [Types.SEARCH_PRODUCTS_FAILURE]: searchProductsFailure,
  [Types.POST_PRODUCTS]: postProducts,
  [Types.POST_PRODUCTS_SUCCESS]: postProductsSuccess,
  [Types.POST_PRODUCTS_FAILURE]: postProductsFailure,
  [Types.EXPORT_OFFERS]: exportOffers,
  [Types.EXPORT_OFFERS_SUCCESS]: exportOffersSuccess,
  [Types.EXPORT_OFFERS_FAILURE]: exportOffersFailure,
  [Types.ACTIVATE_OFFERS]: activateOffers,
  [Types.ACTIVATE_OFFERS_SUCCESS]: activateOffersSuccess,
  [Types.ACTIVATE_OFFERS_FAILURE]: activateOffersFailure,
  [Types.DELETE_OFFERS]: deleteOffers,
  [Types.DELETE_OFFERS_SUCCESS]: deleteOffersSuccess,
  [Types.DELETE_OFFERS_FAILURE]: deleteOffersFailure,
  [Types.IMPORT_OFFERS]: importOffers,
  [Types.IMPORT_OFFERS_SUCCESS]: importOffersSuccess,
  [Types.IMPORT_OFFERS_FAILURE]: importOffersFailure,
  [Types.IMPORT_P_SKU_UNIQUE]: importPSkuUnique,
  [Types.IMPORT_P_SKU_UNIQUE_SUCCESS]: importPSkuUniqueSuccess,
  [Types.IMPORT_P_SKU_UNIQUE_FAILURE]: importPSkuUniqueFailure,
  [Types.EXPORT_PSKU]: exportPSku,
  [Types.EXPORT_PSKU_SUCCESS]: exportPSkuSuccess,
  [Types.EXPORT_PSKU_FAILURE]: exportPSkuFailure,
  };

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/ProductsReducer.js